import Page, { background } from "./page";

import { ReplicaItemType } from "types";
import thumbnail from "./gallery/promo-harry-in-hiding_00.jpg";

const data: ReplicaItemType = {
  id: "the-quibbler-v1-harry-in-hiding-grade-b",
  name: "The Quibbler v1 - Harry in Hiding (Grade B)",
  nameFormatted: {
    primary: "Grade B",
    secondary: "The Quibbler v1",
    tertiary: "Harry in Hiding",
  },
  page: <Page />,
  thumbnail,
  background,
};

export default data;
